import React from 'react'

import { StructureDto } from '@/endpoints/models'

export interface ExtendedTreeNode {
	children?: ExtendedTreeNode[]
	key: string | number
	label?: React.ReactNode
	node: StructureDto
	title: string
}

export const TREE_PANEL_ORDER = 'TREE_PANEL_ORDER'
